"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGame = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _LayoutManager = _interopRequireDefault(require("./Layout/LayoutManager"));
var _pixiAppSingleton = _interopRequireDefault(require("./pixiAppSingleton"));
var _Stats = require("./Stats");
var _PixiGameTicker = require("./PixiGameTicker");
var _PixiGameLoader = require("./PixiGameLoader");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiGame = exports.PixiGame = /*#__PURE__*/function () {
  function PixiGame(useGsapTicker, useLayoutManager) {
    var _this = this;
    _classCallCheck(this, PixiGame);
    _defineProperty(this, "Ticker", void 0);
    _defineProperty(this, "application", void 0);
    _defineProperty(this, "resolution", void 0);
    _defineProperty(this, "_stats", void 0);
    _defineProperty(this, "_layoutManager", void 0);
    // console.log('Registering loader')
    _core.CORE.RegisterLoader(new _PixiGameLoader.PixiGameLoader());
    window['game'] = this;

    // note we use pixies util method rather than our own since pixi is the graphics engine and decides. we dont want to risk a difference.
    if (!_pixi.utils.isWebGLSupported()) {
      (0, _core.reportError)("PIXI WebGL Not Supported");
      var locale = _core.CORE.getState().config.locale;
      switch (locale) {
        case 'ja_JP':
          (0, _core.errorFatal)('<p class="error-h">Web GL対応ブラウザが必要です</p><br>有効にして頂くか、対応しているブラウザをご使用下さい');
          break;
        default:
          (0, _core.errorFatal)('<p class="error-h">Web GL Support Required</p><br>Please enable it or use a browser that supports it.');
          break;
      }
    }

    // say pixi hello when running in dev. to get versions etc.
    if (!_core.platformService.isDev()) {
      _pixi.utils.skipHello();
    }

    // Note, for desktop we hard code DPR to be 2 to ensure texts are not blurry.
    var config = _core.CORE.getState().config;
    var dpr = parseInt(config.dpr);
    var res = dpr ? dpr : window.devicePixelRatio >= 2 ? 2 : 2;

    /// ensure that even if dpr is passed or read from windows as greater than 2, we dont set res as higher than two
    // we only support 1 or 2 as resolution.
    if (res > 2) res = 2;

    // if we play desktop, and dpr parameter was not provided and its not safari desktop then set res to 2.
    // older Retina devices might have issues with this but now (2021-09-17) we say fuck it.
    // safari desktop have severe issues with performance on resolution 2. for now we leave it at 2.
    // seems to be a memory issue on safari 15.1, monterrey on m1's. its super random
    //if (channel === Channel.Desktop) this.resolution = 1;
    // if (channel === Channel.Mobile) this.resolution = 2;
    // else
    //   this.resolution = 2; // blurry on macs
    _core.L.debug("Using Pixi Resolution: " + res);
    this.resolution = res;
    _core.CORE.dispatch((0, _core.setResolution)(this.resolution));
    if (this.resolution == 1) console.log("Game is running in low resolution, this is either due to having a low end device with a DPR of 1 or having failed to implement passing the dpr parameter to the launch url.");else console.log("Game is running in high resolution");
    _pixi.settings.PRECISION_FRAGMENT = _pixi.PRECISION.MEDIUM;
    _pixi.settings.PRECISION_VERTEX = _pixi.PRECISION.HIGH;

    //settings.GC_MODE = GC_MODES.MANUAL;

    // Helps with scaling issues, especially when down scaling. Does make for softer res however.
    _pixi.settings.MIPMAP_TEXTURES = _pixi.MIPMAP_MODES.ON;
    _pixi.extensions.add(_pixi.BatchRenderer);
    //Renderer.registerPlugin('batch', BatchRenderer)

    // instantiate app
    this.application = new _pixi.Application({
      // causes a 20fps performance drop on big screens, however, Native graphics elements tends to become Pixilated with out it. FXAA might help
      antialias: false,
      width: window.innerWidth,
      height: window.innerHeight,
      backgroundColor: 0x000000,
      autoDensity: true,
      resolution: this.resolution,
      powerPreference: "high-performance"
    });
    if (_core.platformService.isDev()) {
      globalThis.__PIXI_APP__ = this.application;
    }
    this.Ticker = new _PixiGameTicker.PixiGameTicker(useGsapTicker, this.application);
    this.application.view.style.position = "fixed";
    document.getElementById("shock-game-container").appendChild(this.application.view);
    _core.CORE.subscribe("config.screenSize", function (windowSize) {
      _this.application.renderer.resize(windowSize.width, windowSize.height);
    });

    //#region LayoutManager
    if (useLayoutManager) {
      this._layoutManager = _LayoutManager["default"];
      this.application.stage.sortableChildren = true;
      this._layoutManager.createGrid(19, 19);
      this.application.stage.addChild(this._layoutManager.getContainer());
    }
    //#endregion

    // we destroy the accessibility manager. we do not use it and it can cause the
    // interaction with the canvas from stopping to work since it adds an overlay.
    this.application.renderer.plugins.accessibility.destroy();
    delete this.application.renderer.plugins.accessibility;
    _pixiAppSingleton["default"].Create(this.application);
    _core.CORE.subscribe("game.gameStatus", function (s) {
      if (s === _core.GameStatus.Idle) {
        //  (this.application.renderer as Renderer).textureGC.run();
      }
    });
    _core.CORE.subscribe('config.showStats', function (v) {
      if (v && !_this._stats) {
        var stats = new _Stats.Stats();
        _this._stats = stats;
        document.body.appendChild(stats.dom);
        requestAnimationFrame(function loop() {
          stats.update();
          requestAnimationFrame(loop);
        });
      }
    });
  }
  return _createClass(PixiGame, [{
    key: "Init",
    value: function Init(locale, language) {
      //Note, we want to use translator! this is for bw comp as well as being able to use local content files for translations as well.
      // if no tUrl is set, we load the translations from the game assets. if tUrl is set, we load from the translator.
      if (!_core.CORE.getState().config.tUrl) {
        // shared translation. note the assumption of path.
        _core.CORE.dispatch((0, _core.load)("assets/shared/i18/" + language + ".json", "language_shared_" + language, {
          languageFile: true
        }));
        // language specific translation. note the assumption of path.
        _core.CORE.dispatch((0, _core.load)('assets/game/i18/' + language + '.json', 'language_' + language, {
          languageFile: true
        }));
      } else (0, _core.loadTranslator)(locale, language);

      // language css class to allow for language specific adjustments in CSS.
      var root = document.documentElement;
      root.className += " " + language;

      /** Special font for the menu when using japanese language. Is then overridden by CSS as well. */
      if (language == "ja_JP") {
        _core.CORE.dispatch((0, _core.load)("assets/shared/fonts/RoundedMplusRegular.css", "RoundedMplusRegular_font"));
        _core.CORE.dispatch((0, _core.load)("assets/shared/fonts/RoundedMplusBold.css", "RoundedMplusBold_font"));
      } else if (["zh_CN", "ru_RU", "vi_VN", "th_TH"].indexOf(language) > -1) {
        _core.CORE.dispatch((0, _core.load)("assets/shared/fonts/" + language + "/LocaleFontRegular.css", "LocaleFontRegular_font"));
        _core.CORE.dispatch((0, _core.load)("assets/shared/fonts/" + language + "/LocaleFontBold.css", "LocaleFontBold_font"));
      }
    }
    /**
     * Should be done last.
     */
  }, {
    key: "Draw",
    value: function Draw() {
      var name = _core.CORE.translate('gamename');
      if (name != 'MISSING') document.title = name;
    }
  }]);
}();
//# sourceMappingURL=PixiGame.js.map